import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import docReady from '../receipts/docReady';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { Homepage } from '@jbhi-fi/components/src/views/Homepage/Homepage';
import { HomepagePropsProvider } from '@jbhi-fi/components/src/context/HomepagePropsProvider';
import { ShopifyProductCompareProvider } from '../contexts/ShopifyProductCompareContext';
import { useContentMetafieldData } from '@jbhi-fi/components/src/hooks/useContentMetafieldData/useContentMetafieldData';
import { ContentfulHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';
import { getSalesLineHours } from '@jbhi-fi/components/src/ContactBlock/utils/salesLine/salesLine';
import { determineContactBlock } from '@jbhi-fi/components/src/ContactBlock/determineContactBlock';

const HOMEPAGE_CONTAINER_ID = 'homepage-container';

docReady(() => {
  const container = document.getElementById(HOMEPAGE_CONTAINER_ID);
  if (!container) return drawDefaultLayout();

  const root = createRoot(container);
  root.render(
    <BaseContentProvider shopifyProductActionsProviderProps={{ attachPageType: 'homepage' }}>
      <ShopifyProductCompareProvider shouldHideCompare>
        <HomepagePropsProvider
          disclaimers={window.Jbhifi.disclaimers}
          useInitialData={useContentMetafieldData<ContentfulHomepage>}
          salesLineHours={getSalesLineHours()}
          contactBlockComponent={determineContactBlock()}
        >
          <DefaultLayout>
            <Homepage />
          </DefaultLayout>
        </HomepagePropsProvider>
      </ShopifyProductCompareProvider>
    </BaseContentProvider>
  );
});
